<template>
    <div>
        <label>{{field.name}}</label>
        <input class="form-control" :list="rand" type="text" :value="startValue" />
        <datalist :id="rand">
            <option v-for="(option, oi) in field.options"  :value="option.label" :data-value="option.value">{{option.label}}</option>
        </datalist>
    </div>
</template>
<script>
    import Icon from "@/components/Icons/Icon.vue";
    export default {
        components: {
            Icon
        },
        props: {
            field: Object
        },
        data() {
            return {
                startValue: ""
            }
        },
        computed: {
            rand() {
                var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
                var uniqid = randLetter + Date.now() + Math.random();
                return uniqid;
            },
        }
    }
</script>